<template>
    <div class="main">
       
        <el-form @submit.native.prevent="onSubmitRemanejamento" :model="formRemanejamento" ref="formRemanejamento" label-position="top">

            <template v-if="propTipoEnsino != 3">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Curso Nacional" prop="referencia_nacional" :rules="[$requiredChange]" key="referencia_nacional">
                            <el-select v-model="formRemanejamento.referencia_nacional" @change="getTurmasRegulares()">
                                <el-option v-for="(curso, i) in cursosNacionais" :key="i" :label="curso.nome" :value="curso.referencia_nacional"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Turma" prop="turma_id" :rules="[$requiredChange]" key="turma_id">
                            <el-select v-model="formRemanejamento.turma_id">
                                <el-option-group v-for="(curso, i) in selectTurmas" :key="i" :label="i">
                                    <template v-for="item in curso">
                                    <el-option :key="item.id" :label="item.vagas_disponiveis" :value="item.id"></el-option>
                                    </template>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>
            <template v-else>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Turma AEE" prop="turma_id" :rules="[$requiredChange]" key="turma_id">
                            <el-select v-model="formRemanejamento.turma_id">
                                <el-option v-for="(item, i) in selectTurmas" :key="i" :label="item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>

            <!--
                Motivo do remanejamento (EDUCAÇÃO item 33).

                A lista vem do cadastro tipificado, filtrada pelo tipo `remanejamento` — não
                é texto livre. A observação só aparece quando o motivo escolhido a exige, e
                é o próprio cadastro que diz isso em `exige_justificativa`.
            -->
            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item label="Motivo do remanejamento" prop="motivo_id" :rules="[$requiredChange]" key="motivo_id">
                        <el-select v-model="formRemanejamento.motivo_id" filterable style="width: 100%;"
                            placeholder="Selecione o motivo" @change="aoTrocarMotivo">
                            <el-option v-for="m in motivos" :key="m.id" :value="m.id" :label="m.nome"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10" v-if="motivoExigeJustificativa">
                <el-col :xs="24">
                    <el-form-item label="Justificativa" prop="motivo_observacao" :rules="[$requiredBlur]" key="motivo_observacao">
                        <el-input v-model="formRemanejamento.motivo_observacao" type="textarea" :rows="2"
                            maxlength="500" placeholder="Este motivo exige justificativa."></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-alert v-if="motivoSelecionado && motivoSelecionado.exige_documento" type="info"
                :closable="false" show-icon class="u-mb-10"
                title="Este motivo exige documento comprobatório."
                description="Anexe o documento no cadastro do aluno."></el-alert>

            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item class="u-text-right u-mt-15">
                        <el-button type="primary" native-type="submit">SALVAR</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>

export default {
    props: ['propMatriculas', 'propInstituicaoId', 'propReferenciaNacional', 'propPeriodoLetivoId', 'propTipoEnsino', "propDataNascimento", "propAlunoId"],
    data: () => ({
        cursos: [],
        formRemanejamento: {
            referencia_nacional: '',
            turma_id: '',
            matriculas: [],
            tipo_ensino: '',
            motivo_id: '',
            motivo_observacao: ''
        },
        motivos: [],
        selectInstituicoes: [],
        selectTurmas: [],
        cursosNacionais: [],
        matricula: {}
    }),
    mounted(){

        this.formRemanejamento.matriculas = JSON.parse(JSON.stringify(this.propMatriculas));
        this.formRemanejamento.tipo_ensino = this.propTipoEnsino;

        this.changeReferenciaNacional();
        this.getMotivos();

    },
    computed: {
        motivoSelecionado () {
            return this.motivos.find(m => m.id === this.formRemanejamento.motivo_id) || null
        },

        /** Quem decide é o cadastro do motivo, não a tela. */
        motivoExigeJustificativa () {
            return !!(this.motivoSelecionado && this.motivoSelecionado.exige_justificativa)
        }
    },
    methods:{

        getMotivos(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/motivo/getAll?tipo=remanejamento`,
                this.$store.getters.getHeaderAuth
            ).then(response => {
                this.motivos = Array.isArray(response.data) ? response.data : [];
            }).catch(() => { this.motivos = []; });
        },

        /* Trocar o motivo limpa a justificativa: o texto do motivo anterior não vale para o novo. */
        aoTrocarMotivo(){
            this.formRemanejamento.motivo_observacao = '';
        },
        changeReferenciaNacional(){
         
            if(this.propTipoEnsino == 3){

                this.getTurmasAee();

            }else{

                this.getRefNacional();
            }
        },
        getRefNacional(){

            if(!this.propReferenciaNacional){

                this.loading = false;
                return false;
            }

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/curso/getRefNacionalByInstituicao`, {i: this.propInstituicaoId, p: this.propPeriodoLetivoId /*, referencia_nacional: this.propReferenciaNacional */}, this.$store.getters.getHeaderAuth).then(response => {

                this.cursosNacionais = JSON.parse(JSON.stringify(response.data));

                this.formRemanejamento.referencia_nacional = this.propReferenciaNacional;

                this.getTurmasRegulares();

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getTurmasRegulares(){

            if(!this.formRemanejamento.referencia_nacional){

                return false;
            }

            window.eventBus.$emit('loading', true);

            let dados = {
                instituicao_id: this.propInstituicaoId, 
                periodo_letivo_id: this.propPeriodoLetivoId, 
                referencia_nacional: this.formRemanejamento.referencia_nacional
            };

            if(this.propAlunoId){
                dados['aluno_id'] = this.propAlunoId;
            }

            if(this.propDataNascimento){
                dados['data_nascimento'] = this.propDataNascimento;
            }

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/turma/getAllByReferenciaNacional`, dados, this.$store.getters.getHeaderAuth).then(response => {

                this.formRemanejamento.turma_id = '';
                this.selectTurmas = response.data.turmas;
                window.eventBus.$emit('loading', false);

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

        },
        getTurmasAee(){

            window.eventBus.$emit('loading', true);


            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/turma/getAllAeeByInstituicao`, {instituicao_id: this.propInstituicaoId, periodo_letivo_id: this.propPeriodoLetivoId}, this.$store.getters.getHeaderAuth).then(response => {

                this.formRemanejamento.turma_id = '';
                this.selectTurmas = response.data;
                window.eventBus.$emit('loading', false);

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

        },
        onSubmitRemanejamento(){

            this.$refs.formRemanejamento.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/matricula/remanejarMatriculas`, this.formRemanejamento, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.throw !== 'undefined'){

                        window.eventBus.$emit('loading', false);

                        // window.eventBus.$emit('throw', response.data.throw.msg);

                        this.$alert(response.data.throw.msg, 'Atenção!', { dangerouslyUseHTMLString: true, confirmButtonText: 'OK' }).then(() => { }).catch(() => { });

                        // window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.$emit('onSubmitRemanejamento');
                    }

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});

        },
    },
    components:{  }
}
</script>
